import { useCallback } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { useAppActions } from '../../AppContext'
import { ICON_SM, ICON_XS } from '../../common/theme'
import type { Question } from '../../types'
import iconAdvEdit from '../../img/pencil_1639176.png'

interface Props {
  question: Question
  testId?: string
  disabled?: boolean
}

// "Open in Advanced Edit" affordance — refers the focused question to
// the advedit tab via `referQuestionToTab`, which snapshots it as a
// fresh temp question and bumps `currentQuestionSetTrigger` so the tab
// resets its version state. Reused wherever the answer header wants to
// hand the user off to the Advanced Edit workflow.
export default function OpenInAdvancedEditButton({ question, testId, disabled }: Props) {
  const { referQuestionToTab } = useAppActions()
  const handleClick = useCallback(() => {
    referQuestionToTab(question, 'advedit')
  }, [question, referQuestionToTab])
  return (
    <Tooltip title="Advanced Edit">
      <IconButton size="small" onClick={handleClick} sx={{ p: 0.375 }} data-testid={testId}>
        <img src={iconAdvEdit} alt="Score & Fix" style={{ width: ICON_XS, height: ICON_XS }} />
      </IconButton>

      {/* <span>
        <IconButton
          size="small"
          disabled={disabled}
          onClick={handleClick}
          sx={{ p: 0.375 }}
          data-testid={testId}
        >
          <EditOutlinedIcon sx={{ fontSize: ICON_XS }} />
        </IconButton>
      </span> */}
    </Tooltip>
  )
}
